import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Link } from "react-router-dom";
import useSWR from "swr";
import { getHomeImages, imageUrlFor } from "../sanity/client";

export default function About() {
  const { data: images = [] } = useSWR("home-images", getHomeImages);

  return (
    <>
      <div className="border-orange-600 border mb-8 p-8 bg-orange-100 flex justify-between flex-col sm:flex-col lg:flex-row">
        <h2 className="font-bold text-2xl mt-1">
          Donate to help sustain Scribble
        </h2>
        <Link className="no-underline" to="/donate">
          <div className="py-2 px-4 no-underline bg-scribbleorange text-white font-bold">
            More info &rarr;
          </div>
        </Link>
      </div>
      <h2 className="text-2xl font-bold mb-8">
        Scribble is a nonprofit counseling center and community events venue
        located in Highland Park, Los Angeles. <br />
        <br /> Our counseling center is located at 5531 York Blvd and provides
        sliding scale mental health services for individuals, couples, families
        and groups. You can learn more about our therapy services{" "}
        <a href="https://www.scribblecommunity.com/therapy">here</a>. <br />
        <br />
        Our venue is located at 5541 York Blvd and hosts all-ages shows, talks,
        classes, and workshops with an emphasis on community building. You can
        learn more about our venue{" "}
        <a href="https://www.scribblecommunity.com/venue">here</a>.
      </h2>
      <Carousel autoPlay showThumbs={false}>
        {images &&
          images
            ?.sort((a: any, b: any) => a.sortOrder - b.sortOrder)
            .map((item: any, i: number) => (
              <div key={i}>
                {item.image && (
                  <img alt="" src={imageUrlFor(item.image).width(1000).url()} />
                )}
              </div>
            ))}
      </Carousel>
      <div style={{ marginBottom: "100px" }} />
    </>
  );
}
